<template>
    <div class="status-pill" :style="{ color: statusFontColor, background: statusBackgroundColor }">
        {{ lowercaseText }}
    </div>
</template>

<script>

export const Status = Object.freeze({
    SUCCESS: 'SUCCESS',
    WARNING: 'WARNING',
    MUTED: 'MUTED',
    DANGER: 'DANGER'
})

export const StatusFontColor = Object.freeze({
    SUCCESS: '#28B18F',
    WARNING: '#BB8340',
    MUTED: '#9E9E9E',
    DANGER: '#E76666',
})

export const StatusBackgroundColor = Object.freeze({
    SUCCESS: '#D3F5ED',
    WARNING: '#F4CFA2',
    MUTED: '#E7E7E7',
    DANGER: '#FFD8DF',
})

export default {
    name: 'StatusPill',
    props: {
        status: {
            type: String,
            required: true,
            validator(value) {
                return Object.values(Status).includes(value.toUpperCase());
            },
            default: Status.WARNING
        },
        text: {
            type: String,
            default: Status.WARNING
        },
    },
    computed: {
        statusValue() {
          return this.status.toUpperCase()
        },
        statusFontColor() {
            return StatusFontColor[this.statusValue]
        },
        statusBackgroundColor() {
            return StatusBackgroundColor[this.statusValue]
        },
        lowercaseText() {
            return this.text.toLowerCase()
        }
    },
}
</script>

<style lang="scss" scoped>
    .status-pill {
        padding: 5px 10px;
        font-weight: bold;
        border-radius: 5px;
        display: inline-block;
        text-transform: capitalize;
    }
</style>
